import React from "react";

import CodeInput from "./CodeInput"

import Input from "./Input";
import SmartList from "../common/SmartList";

export default class AdditionalFiscalReferences extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editable: props.editable,
            additionalFiscalReferences: props.additionalFiscalReferences
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState(nextProps)
    }

    _renderAdditionalFiscalReference(reference, index){
        let {
            editable,
            additionalFiscalReferences
        } = this.state

        const hidden = this.props.hidden

        return (
            <div className="form-group row mb-5">
                <div
                  className="col-md-6"
                  hidden={hidden("additional_fiscal_references.code")}
                >
                    <CodeInput
                        placeholder={"Code"}
                        listKey={"AdditionalFiscalRefRoleCode"}
                        value={reference.code}
                        editable={editable}
                        onSelected={option => {
                            additionalFiscalReferences[index].code = option
                            this.props.onUpdated(additionalFiscalReferences)
                        }}
                    />
                </div>
                <div
                  className="col-md-6"
                  hidden={hidden("additional_fiscal_references.identifier")}
                >
                    <Input
                        type="text"
                        placeholder="VAT Number"
                        value={reference.identifier}
                        editable={editable}
                        onChange={identifier => {
                            additionalFiscalReferences[index].identifier = identifier
                            this.props.onUpdated(additionalFiscalReferences)
                        }}
                    />
                </div>
            </div>
        )
    }


    render() {
        let {
            editable,
            additionalFiscalReferences,
        } = this.state

        let itemName = "Additional Fiscal Reference"
        return (
            <SmartList
                minimal
                items={additionalFiscalReferences}
                itemName={itemName}
                showItemName={true}
                canDelete={editable}
                canAdd={editable}
                renderItem={(item, index) => this._renderAdditionalFiscalReference(item, index)}
                renderDelete={(item, index) => (
                    <a
                        className="btn btn-sm btn-light-danger"
                        onClick={() => {
                            additionalFiscalReferences.splice(index, 1)
                            this.props.onUpdated(additionalFiscalReferences)
                        }}
                    >
                        <i className="la la-trash-o fs-3"></i>
                        {itemName}
                    </a>
                )}
                onUpdated={items => {
                    additionalFiscalReferences = items
                    this.props.onUpdated(additionalFiscalReferences)
                }}
                onAddItemPressed={() => {
                    additionalFiscalReferences.push({})
                    this.props.onUpdated(additionalFiscalReferences)
                }}
            />
        )
    }


}

AdditionalFiscalReferences.defaultProps = {

}
